const scrollMagic = new ScrollMagic.Controller();

function setInview(element) {
  new ScrollMagic.Scene({
    triggerElement: element,
    triggerHook: 0.7,
    reverse: false,
  })
    .setClassToggle(element, '-inview')
    .addTo(scrollMagic);
}

export default function inview() {
  const inviewTarget = document.querySelectorAll('.js-inview');

  inviewTarget.forEach(element => {
    setInview(element);
  });
}
